import React from "react";
import { Badge } from "react-bootstrap";

// Anything that wasn't an audit used to read "Live", so captures and session replays were mislabelled.
const RUN_TYPE_BADGE: Record<string, { label: string; bg: string; text?: "dark" }> = {
  live: { label: "Live", bg: "primary" },
  audit: { label: "Audit", bg: "warning", text: "dark" },
  capture: { label: "Capture", bg: "info", text: "dark" },
  session: { label: "Session", bg: "secondary" },
};

export const RunTypeBadge: React.FC<{ runType?: string | null }> = ({ runType }) => {
  const meta = RUN_TYPE_BADGE[runType ?? "live"] ?? { label: runType ?? "Live", bg: "secondary" };
  return (
    <Badge bg={meta.bg} text={meta.text}>
      {meta.label}
    </Badge>
  );
};
